/**
 * Template rendering and token helpers for message templates.
 */

export function renderTemplate(body: string, vars: Record<string, string>): string {
  return body.replace(/\{(\w+)\}/g, (_, key) => (vars[key] ?? '').trim());
}

export const TEMPLATE_TOKENS = [
  '{first_name}',
  '{last_name}',
  '{company}',
  '{city}',
] as const;

export function extractVariables(body: string): string[] {
  const matches = body.match(/\{([a-z_]+)\}/gi) ?? [];
  return [...new Set(matches.map((m) => m.slice(1, -1).toLowerCase()))];
}

export function insertAtCursor(el: HTMLTextAreaElement, text: string): string {
  const start = el.selectionStart ?? 0;
  const end = el.selectionEnd ?? 0;
  const before = el.value.slice(0, start);
  const after = el.value.slice(end);
  const next = before + text + after;
  const nextPos = start + text.length;
  el.value = next;
  requestAnimationFrame(() => {
    el.focus();
    el.setSelectionRange(nextPos, nextPos);
  });
  return next;
}
